import CardHeader from "../../components/Shared/CardHeader";
import Loader from "../../components/Shared/Loader";
import { useState } from "react";
import { useCompany } from "../../hooks/useCompany";
import "./styles.css";
import { Tabs } from "antd";
import Materials from '../Materials/index'
import ThirdPartyServices from '../ThirdPartyService/index'
import OtherExpenditure from '../OtherExpenditure'; 
import { useCan } from '../../hooks/useCan';
import NotFound from '../NotFound';

export default function Expenditure() {
    const [loading, setLoading] = useState(false);
    const { company } = useCompany();
    const permissionTransformer = useCan({ rolesCan: ["Transformer","Administrator","Consultant","Internal","Trainee"] });
    const tabItems = [
        {
            label: 'Materiais de Consumo',
            key: '1',
            children: <><Materials /></>,
        },
        {
            label: 'Serviços de Terceiros',
            key: '2',
            children: <><ThirdPartyServices /></>,
        },
        {
            label: 'Outros dispêndio',
            key: '3',
             children: <><OtherExpenditure /></>,
        },
    
    ]
    return (
        <>
            {loading && <Loader />}
            {permissionTransformer ?
                <div className='card '>
                    <CardHeader
                        pageName={"Dispêndios"}
                        hasPageBefore={false}
                    />
                    <div className='tab-div'>
                        <Tabs
                            defaultActiveKey="1"
                            items={tabItems}
                        />
                    </div>
                </div>
                :
                <div className='notfound-div'>
                    <NotFound />
                </div>

            }
        </>
    )
}